// import React from "react";
// import { Box } from "@mui/material";

// export default function Hero() {
//     // 1) Coloque o arquivo em: public/hero.mp4
//     // 2) Ele será servido em: /hero.mp4
//     const videoSrc = `${process.env.PUBLIC_URL}/hero.mp4`;

//     return (
//         <Box
//             id="inicio"
//             sx={{
//                 position: "relative",
//                 minHeight: { xs: "86vh", md: "92vh" },
//                 width: "100%",
//                 overflow: "hidden",
//                 backgroundColor: "var(--preto)", // fallback se o vídeo não carregar
//             }}
//         >
//             <Box
//                 component="video"
//                 src={videoSrc}
//                 autoPlay
//                 muted
//                 loop
//                 playsInline
//                 preload="auto"
//                 controls={false}
//                 onError={(e) => {
//                     // se não encontrar o arquivo, deixa só o fundo preto
//                     e.currentTarget.style.display = "none";
//                 }}
//                 sx={{
//                     position: "absolute",
//                     inset: 0,
//                     width: "100%",
//                     height: "100%",
//                     objectFit: "cover",
//                     objectPosition: "center",
//                 }}
//             />
//         </Box>
//     );
// }


import React from "react";
import { Box, Button, Container, Stack, Typography } from "@mui/material";

export default function Hero() {
    const videoSrc = `${process.env.PUBLIC_URL}/hero.mp4`;

    const scrollToId = (id) => {
        const el = document.getElementById(id);
        if (!el) return;
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <Box
            id="inicio"
            sx={{
                position: "relative",
                minHeight: { xs: "86vh", md: "92vh" },
                width: "100%",
                overflow: "hidden",
                backgroundColor: "var(--preto)",
                display: "flex",
                alignItems: "center",
            }}
        >
            <Box
                component="video"
                src={videoSrc}
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                controls={false}
                onError={(e) => {
                    e.currentTarget.style.display = "none";
                }}
                sx={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "center",
                }}
            />

            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    background:
                        "linear-gradient(180deg, rgba(0,0,0,0.22) 0%, rgba(0,0,0,0.52) 55%, rgba(0,0,0,0.84) 100%)",
                }}
            />

            <Container sx={{ position: "relative", zIndex: 2 }}>
                <Box sx={{ maxWidth: 900 }}>
                    <Typography
                        sx={{
                            color: "var(--verdeClaro)",
                            fontWeight: 900,
                            letterSpacing: "0.22em",
                            textTransform: "uppercase",
                            fontSize: 12,
                            mb: 2,
                        }}
                    >
                        Lusco Produtora
                    </Typography>

                    <Typography
                        sx={{
                            color: "var(--branco)",
                            fontWeight: 1000,
                            lineHeight: 0.98,
                            letterSpacing: "-0.04em",
                            fontSize: { xs: "2.8rem", sm: "4.2rem", md: "6rem" },
                            maxWidth: 820,
                            mb: 2.5,
                        }}
                    >
                        Onde a luz começa.
                    </Typography>

                    <Typography
                        sx={{
                            color: "rgba(255,255,255,0.92)",
                            fontWeight: 700,
                            fontSize: { xs: "1.02rem", md: "1.28rem" },
                            lineHeight: 1.5,
                            maxWidth: 780,
                            mb: 2,
                        }}
                    >
                        Não entregamos vídeos. Criamos impacto visual com intenção emocional.
                    </Typography>

                    <Typography
                        sx={{
                            color: "rgba(255,255,255,0.72)",
                            fontSize: { xs: "0.96rem", md: "1.08rem" },
                            lineHeight: 1.8,
                            maxWidth: 760,
                            mb: 4,
                        }}
                    >
                        A Lusco existe para transformar energia em imagem — e imagem em desejo.
                        Cada projeto nasce com um objetivo claro: capturar atenção, gerar impacto
                        e elevar percepção.
                    </Typography>

                    <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
                        <Button
                            variant="contained"
                            size="large"
                            onClick={() => scrollToId("contato")}
                            sx={{
                                bgcolor: "var(--verdeClaro)",
                                color: "var(--preto)",
                                fontWeight: 1000,
                                borderRadius: 999,
                                px: 3.2,
                                py: 1.4,
                                "&:hover": { bgcolor: "var(--verdeClaro)" },
                            }}
                        >
                            Falar com a Lusco
                        </Button>

                        <Button
                            variant="outlined"
                            size="large"
                            onClick={() => scrollToId("videos")}
                            sx={{
                                color: "var(--branco)",
                                borderColor: "rgba(255,255,255,0.22)",
                                fontWeight: 900,
                                borderRadius: 999,
                                px: 3.2,
                                py: 1.4,
                                "&:hover": {
                                    borderColor: "rgba(172,201,14,0.45)",
                                    backgroundColor: "rgba(255,255,255,0.04)",
                                },
                            }}
                        >
                            Ver trabalhos
                        </Button>
                    </Stack>
                </Box>
            </Container>
        </Box>
    );
}